import { ViewModel } from '../view-model';

export class ActivityStep implements ViewModel {
  friendlyTypeNameSingular: string = 'Activity Step';
  apiRoute: string;

  id: string;
  step: number;
  description: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;
    this.step = data.step;
    this.description = data.description;
  }
}
